import { useMemo } from 'react';

import { useActiveUserClasses } from 'src/hooks/use-active-user-classes';
import { useIsMClassUserCheck } from 'src/hooks/use-is-mclass-user-check';
import { useOnboardingUserInfo } from 'src/hooks/use-onboarding-user-info';
import AuthService from 'src/services/api/auth.service';
import { useGetSchoolsAndGradesMESQuery } from 'src/store/api/entryways';

export const useGradesForFiltering = (): string[] => {
  const isTeacher = AuthService.isTeacher();
  const { data: onboardingUserInfo } = useOnboardingUserInfo();
  const { activeUserClasses } = useActiveUserClasses();
  const { isMClassUser } = useIsMClassUserCheck();
  const { data: mESGradesData } = useGetSchoolsAndGradesMESQuery(undefined, {
    skip: !isTeacher && !isMClassUser,
  });

  return useMemo(() => {
    if (isTeacher) {
      // Teacher: use active class grades + mES grades (using proper grade extraction)
      const classGrades = activeUserClasses
        ? activeUserClasses
            .map((cls) => cls.grades)
            .flat()
            .filter(Boolean)
        : [];

      // Handle Google Classroom special case like getAllUserGrades does
      const hasGCClasses = activeUserClasses?.find(
        (cls) => cls.metadata.isGoogleClassroomCourse,
      );

      let allClassGrades = classGrades;
      if (hasGCClasses && !classGrades.length) {
        allClassGrades = ['Other'];
      }

      const mesGrades = mESGradesData ? [mESGradesData] : [];
      return [...allClassGrades, ...mesGrades].map((grade) => String(grade));
    } else {
      // Student: use onboarding org grades, don't hide if no grades
      return onboardingUserInfo?.grades ?? [];
    }
  }, [isTeacher, activeUserClasses, mESGradesData, onboardingUserInfo]);
};
